module.exports = __webpack_public_path__ + "static/media/nucleo-icons.0b8a30b1.svg";